import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import LiveJobStrip from "@/components/LiveJobStrip";
import LandingPage from "@/pages/LandingPage";
import CatalogPage from "@/pages/CatalogPage";
import ExpertDetailPage from "@/pages/ExpertDetailPage";
import ProgressPage from "@/pages/ProgressPage";
import AppDownloadPage from "@/pages/AppDownloadPage";
import CheckoutCancelPage from "@/pages/CheckoutCancelPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import MissionPage from "@/pages/MissionPage";
import LibraryPage from "@/pages/LibraryPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ContactPage from "@/pages/ContactPage";
import TrainPage from "@/pages/TrainPage";
import { adoptClaimFromUrl } from "@/lib/api";

// 2026-09-25 (L28): if the Experts app opened this page with #claim=…,
// adopt it before any component asks for the claim. Module-load time, on
// purpose — earlier than any effect, so the first request already carries it.
// 2026-10-27: the APK's Train button opens nowifiai.com/#claim=… — that person came to train,
// so the first landing goes straight to the Train page (once; Home works normally after).
let cameToTrain = !!adoptClaimFromUrl();
function Home() {
  if (cameToTrain) { cameToTrain = false; return <Navigate to="/train" replace />; }
  return <LandingPage />;
}

/** Old /catalog/:slug links keep working. */
function OldExpertLink() {
  const { slug } = useParams();
  return <Navigate to={`/experts/${slug}`} replace />;
}

/**
 * 2026-10-27 — the site in the app's design (Dog: "the website should follow a lot of the
 * feel of the new app"). /experts is the catalog; /train is the training page; /catalog
 * and /mission stay as redirects so nothing published goes dead.
 */
export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[color:var(--ex-bg)] text-[color:var(--ex-text)]">
        <TopBar />
        <LiveJobStrip />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experts" element={<CatalogPage />} />
          <Route path="/experts/:slug" element={<ExpertDetailPage />} />
          <Route path="/catalog" element={<Navigate to="/experts" replace />} />
          <Route path="/catalog/:slug" element={<OldExpertLink />} />
          <Route path="/train" element={<TrainPage />} />
          <Route path="/progress/:jobId" element={<ProgressPage />} />
          <Route path="/app" element={<AppDownloadPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/about" element={<MissionPage />} />
          <Route path="/mission" element={<Navigate to="/about" replace />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#17171a", border: "1px solid #2a2a2f", color: "#f2f2f2", fontFamily: "Inter, sans-serif" } }} />
      </div>
    </BrowserRouter>
  );
}
